import React, {useEffect, useState} from 'react'
import ColorPicker, {useColorPicker} from 'react-best-gradient-color-picker'
import {Calendar, momentLocalizer} from 'react-big-calendar-scheduler'
import moment from 'moment'
import {toAbsoluteUrl} from '../../_metronic/helpers'

import axios from 'axios'
import {ConceptoItem} from '../components/ConceptoItem.js'

import Events from '../resources/Events.js'

function Test() {
  const localizer = momentLocalizer(moment)

  const [conceptos, setConceptos] = useState('')
  const [videoInfo, setVideoInfo] = useState('')
  const [color, setColor] = useState(
    'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(255,255,255,1) 100%)'
  )
  const {setSolid, setGradient} = useColorPicker(color, setColor)

  const url = 'http://localhost/punto-sur-backend/'

  useEffect(() => {
    getVideoData()
    getConceptData()
  }, [])

  const getVideoData = () => {
    axios.get('http://localhost/punto-sur-backend/getVideoInfo.php').then(function (response) {
      setVideoInfo(response.data.data[0])

      // Video Reload
      const videoElement = document.getElementById('home-video-fondo')
      const sourceElement = document.createElement('source')
      sourceElement.setAttribute('id', 'home-video-fondo-source')
      sourceElement.setAttribute('src', response.data.data[0].fullUrl)
      videoElement.appendChild(sourceElement)
    })

    const data = new FormData()
    data.append('name', 'home-video-color')
    axios
      .post('http://localhost/punto-sur-backend/getInitialData.php', data, {})
      .then(function (response) {
        // console.log(response.data.data[0].elemento)
        setColor(response.data.data[0].elemento)
      })
  }

  const getConceptData = () => {
    axios
      .get(url + 'getConceptData.php')
      .then((response) => {
        const conceptos = response.data.data
        setConceptos(conceptos)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadFile = () => {}

  const VideoUploader = () => {}

  const submitColor = () => {}

  return (
    <div className='row g-5'>
      {/* VIDEO */}
      <div className='col-lg-6'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Video de fondo</h3>
          </div>
          <div className='card-body'>
            <p>Video Actual</p>
            <video id='home-video-fondo' controls>
              {/* <source id='home-video-fondo-source' src={videoInfo.fullUrl} /> */}
              Tu navegador no soporta la tag video.
            </video>
          </div>
          <div className='card-footer'>
            <VideoUploader name='home-video-fondo' />
          </div>
        </div>
      </div>

      <div className='col-lg-6'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Colores del degradado de video</h3>
          </div>
          <div className='card-body'>
            <ColorPicker
              value={color}
              onChange={setColor}
              hidePresets={false}
              hideControls={true}
            />
          </div>
          <div className='card-footer'>
            <button className='btn btn-primary float-end' onClick={() => submitColor()}>
              Guardar
            </button>
          </div>
        </div>
      </div>

      {/* PROMOCIONES */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Carousel de promociones</h3>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-lg-4'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-1.jpg')}
                        alt=''
                        className='w-100 rounded home-promociones-1'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-promociones-1'
                          name='file-promociones-1'
                          className='input-image'
                          onChange={() => uploadFile('promociones-1')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-promociones-1').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-2.jpg')}
                        alt=''
                        className='w-100 rounded home-promociones-2'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-promociones-2'
                          name='file-promociones-2'
                          className='input-image'
                          onChange={() => uploadFile('promociones-2')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-promociones-2').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-3.jpg')}
                        alt=''
                        className='w-100 rounded home-promociones-3'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-promociones-3'
                          name='file-promociones-3'
                          className='input-image'
                          onChange={() => uploadFile('promociones-3')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-promociones-3').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer'>
            <button className='btn btn-primary float-end'>Guardar</button>
          </div>
        </div>
      </div>

      {/* CALENDARIO */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Fechas de calendario</h3>
          </div>
          <div className='card-body'>
            <Calendar
              localizer={localizer}
              events={Events}
              startAccessor='start'
              endAccessor='end'
              style={{height: 800}}
            />
          </div>
          <div className='card-footer'>
            <button className='btn btn-primary float-end'>Guardar</button>
          </div>
        </div>
      </div>

      {/* CAROUSEL */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Imágenes de carousel Concepto</h3>
          </div>
          <div className='card-body'>
            <div className='row' id='carousel-concepto'>
              <ConceptoItem conceptos={conceptos} />
            </div>
          </div>
          <div className='card-footer'>
            <button className='btn btn-primary float-end'>Guardar</button>
          </div>
        </div>
      </div>

      {/* SERVICIOS */}

      {/* END ROW */}
    </div>
  )
}

export {Test}
